<template>
  <div
    class="notifications"
    :style="`bottom: ${offset.y}px; right: ${offset.x}`"
  >
    <v-scale-transition origin="center" group tag="ul">
      <v-list-item
        v-for="notification in notifications"
        :key="notification.id + '-notification'"
        class="px-3"
      >
        <v-sheet
          dark
          elevation="6"
          rounded
          width="100%"
          class="notification d-flex align-center px-4 py-3 mb-3"
          :class="{
            'red darken-4': notification.type === 'error'
          }"
        >
          <div
            class="flex-fill font-weight-medium text-body-1 d-flex align-center"
          >
            <v-icon
              color="success"
              v-if="notification.type === 'success'"
              class="mr-4"
              >mdi-check-circle</v-icon
            >
            <v-icon v-else-if="notification.type === 'error'" class="mr-4"
              >$error</v-icon
            >
            <span class="flex-fill" v-html="notification.message"></span>
          </div>
          <v-btn x-small class="ml-4" icon @click="close(notification.id)"
            ><v-icon>$close</v-icon></v-btn
          >
        </v-sheet>
      </v-list-item>
    </v-scale-transition>
  </div>
</template>

<style>
.notifications {
  position: fixed;
  z-index: 3000;
  max-width: 500px;
  width: 100%;
  opacity: 0.97;
}
</style>

<script>
export default {
  computed: {
    notifications() {
      return this.$store.state.notifications.queue;
    },
    offset() {
      return this.$store.state.notifications.offset;
    }
  },
  methods: {
    close(id) {
      this.$store.commit("notifications/remove", id);
    }
  }
};
</script>
